export default "__VITE_ASSET__fabRHovq__"